import { render, staticRenderFns } from "./nav-data-publisher.vue?vue&type=template&id=77c7711c&"
import script from "./nav-data-publisher.vue?vue&type=script&lang=ts&"
export * from "./nav-data-publisher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports